// extracted by mini-css-extract-plugin
module.exports = {"laptop":"(min-width: 1025px)","tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","header":"header-2hU7T","insurances":"insurances-2pGRF"};